/**
 * Function to wait for predicates.
 * taken from: https://gist.github.com/chrisjhoughton/7890239
 * @param {function() : Boolean} predicate - A function that returns a bool
 * @param {Object} [options] - Optional [timeout] maximum waiting time in ms after rejected, [logger] Optional logger
 */
export function waitFor(predicate: () => boolean, options?: { timeout?: number; logger?: Console }) {
  return new Promise((resolve, reject) => {
    const check = () => {
      options?.logger?.debug('waitFor checking', predicate());
      if (!predicate()) return;
      clearInterval(interval);
      resolve(true);
    };
    const interval = setInterval(check, 100);
    check();

    if (!options?.timeout) return;
    setTimeout(() => {
      clearInterval(interval);
      reject();
    }, options.timeout);
  });
}
